import React, { useContext, useEffect } from "react";
import { Router, useLocation } from "@reach/router";
import { UserContext } from "../context/UserContext";
import MobileMenu from "../components/common/MobileMenu";
import PanelNavbar from "../components/global/PanelNavbar";
import MiInformacion from "./MiInformacion";
import { navigate } from "@reach/router";
import SingleCurso from "./SingleCurso";
import MisMetodos from "./MisMetodos";
import Pagos from "./Pagos";
import Sorry from "./Sorry";
import CourseAccesses from "./CourseAccesses";

const Panel = () => {
  const { user, signOut } = useContext(UserContext);

  const location = useLocation();

  useEffect(() => {
    if (user !== null && location.pathname === "/mylatina") {
      handleInstructor(user);
    }
  }, [user, location]);

  const handleInstructor = (user) => {
    const { purchases } = user;
    const courses = new Set();
    purchases.forEach(({ course_id }) => {
      if (course_id !== null) {
        courses.add(course_id);
      }
    });
    const isInstructor = courses.has(4);
    if (isInstructor) {
      return navigate("/mylatina/courses/4");
    }
    return navigate("/mylatina/account");
  };

  return (
    <div className="container-fluid px-0">
      <MobileMenu signOut={signOut} user={user} />
      <div className="sidebar">
        <PanelNavbar user={user} signOut={signOut} />
      </div>
      <div className="main-panel px-4">
        <div className="content overflow-x-hidden">
          <Router>
            <SingleCurso path="/courses/:course_id/*" />
            <CourseAccesses path="/accesos" />
            <MiInformacion path="/account" />
            <MisMetodos path="/metodos" />
            <Pagos path="/pagos" />
            <Sorry path="/sorry/:course_id/*" />
          </Router>
        </div>
      </div>
    </div>
  );
};

export default Panel;
